const initialState = {
  equipmentModels: [],
  signee: []
};

export default initialState;
